// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__g6QhN","buttons":"SendReceipts_buttons__2LyN9","email":"SendReceipts_email__VCTTC","bookApptTitle":"SendReceipts_bookApptTitle__2aqy-"};